package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_profile_data_di_ProfileModule : Module get() = module {
	single() { _ -> com.essntl.features.profile.data.repository.ProfileRepositoryImpl(supabase=get()) } bind(com.essntl.features.profile.domain.repository.ProfileRepository::class)
	single() { _ -> com.essntl.features.profile.data.supabase.ProfileSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.profile.data.supabase.ProfileSupabaseDataSource::class)
}
public val com.essntl.features.profile.data.di.ProfileModule.module : org.koin.core.module.Module get() = com_essntl_features_profile_data_di_ProfileModule
